(() => {
  if (window.codexMegaMenuTracking) return;
  window.codexMegaMenuTracking = true;

  const events = {
    link: 'nav_dropdown_link_click',
    tile: 'nav_featured_tile_click',
    cta: 'nav_closing_cta_click',
    p50_card: 'nav_p50_card_click',
  };

  const push = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  const viewOf = (element) => (element.closest('.codex-mm-m, .codex-mm-l1') ? 'mobile' : 'desktop');

  const setActivePanel = (details) => {
    details.classList.remove('codex-mm-top--leaving');
    document.querySelectorAll('details.codex-mm-top[open]').forEach((other) => {
      if (other !== details) other.classList.add('codex-mm-top--leaving');
    });
  };

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('codex-mm-top')) return;
      if (details.open) setActivePanel(details);
      else details.classList.remove('codex-mm-top--leaving');
    },
    true
  );

  document.addEventListener('mouseover', (event) => {
    const summary = event.target.closest && event.target.closest('details.codex-mm-top > summary');
    if (summary) setActivePanel(summary.parentElement);
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      const panel = details.querySelector(':scope .codex-mm, :scope .codex-mm-m');
      if (!panel) return;
      push({ event: 'nav_l1_open', nav_item: panel.dataset.l1, nav_view: viewOf(panel) });
    },
    true
  );

  // Keyboard: Space toggles a panel, Escape closes it and returns focus to its label.
  let refocusing = null;
  document.addEventListener(
    'focusin',
    (event) => {
      if (refocusing && event.target === refocusing) event.stopPropagation();
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    const details = event.target.closest && event.target.closest('details.codex-mm-top');
    if (!details) return;
    const summary = details.querySelector(':scope > summary');

    if (event.key === ' ' && event.target === summary) {
      event.preventDefault();
      details.open = !details.open;
    } else if (event.key === 'Escape' && details.open) {
      details.open = false;
      refocusing = summary;
      summary.focus();
      refocusing = null;
    }
  });

  // The full-height drawer has to leave the header's stacking context while open.
  // ModalComponent already moves drawers to <body> when this getter is true.
  document.querySelectorAll('menu-drawer.codex-mm-drawer').forEach((drawer) => {
    Object.defineProperty(drawer, 'requiresBodyAppended', { get: () => true });
  });

  // Every grouped card starts closed when a dropdown screen opens.
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('details.codex-mm-l1 > summary');
    if (!summary) return;
    summary.parentElement.querySelectorAll('details.codex-mm-card[open]').forEach((card) => {
      if (card.codexAnimation) card.codexAnimation.cancel();
      card.open = false;
    });
  });

  // Grouped cards animate their height when opened or closed.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('details.codex-mm-card > summary');
    if (!summary || reduceMotion.matches) return;
    const card = summary.parentElement;
    if (card.codexAnimation) return;
    event.preventDefault();

    const opening = !card.open;
    const startHeight = card.offsetHeight;
    card.open = !card.open;
    const endHeight = card.offsetHeight;
    card.open = true;
    card.classList.toggle('codex-mm-card--closing', !opening);

    card.style.overflow = 'hidden';
    card.codexAnimation = card.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: 200, easing: 'ease-out' }
    );
    card.codexAnimation.onfinish = card.codexAnimation.oncancel = () => {
      card.open = opening;
      card.classList.remove('codex-mm-card--closing');
      card.style.overflow = '';
      card.codexAnimation = null;
    };
  });

  // The drawer search field hands off to the header's predictive search.
  document.addEventListener('click', (event) => {
    const field = event.target.closest('[data-codex-drawer-search]');
    if (!field) return;
    const drawer = field.closest('menu-drawer');
    const input = document.querySelector('header .header__search input[type="search"]');
    if (!drawer || !input || typeof drawer.hide !== 'function') return;
    event.preventDefault();
    drawer.activeElement = input;
    drawer.hide();
  });

  document.addEventListener('click', (event) => {
    const target = event.target.closest('.codex-mm [data-nav-event], .codex-mm-m [data-nav-event]');
    if (!target || !events[target.dataset.navEvent]) return;
    const panel = target.closest('[data-l1]');
    const column = target.closest('[data-nav-column]');
    const payload = {
      event: events[target.dataset.navEvent],
      nav_item: panel ? panel.dataset.l1 : undefined,
      nav_view: viewOf(target),
      link_url: target.getAttribute('href'),
    };
    if (column) payload.nav_column = column.dataset.navColumn;
    if (target.dataset.navTile) payload.nav_tile = target.dataset.navTile;
    else payload.link_text = target.textContent.trim();
    push(payload);
  });
})();
